import React, {useState} from "react";
import {
  Box,
  InputLabel,
  TextField,
  DialogTitle,
  DialogActions,
  Button,
	Dialog,
	useMediaQuery,
	Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import { ReactComponent as CloseIconRed } from "../../assests/icons/close_icon_red.svg";

const SuccessDialog = (props) => {
	const dispatch = useDispatch();
	const [open, setOpen] = useState(true);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	const handleClose = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
  };
	
  return (
		<Box>
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      maxWidth={false}
    >
      <Box
        sx={{
          padding: "2rem",
          width: "69rem",
          height: "21rem",
          columnGap: "2rem",
          overflow: "hidden",
          borderRadius: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            paddingBottom: "0.2rem",
            borderBottom: "1px solid #c8c8c8",
          }}
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{
              margin: "auto",
              padding: "0",
              fontSize: "2.5rem",
              color: "#cf2030",
            }}
          >
            {props.headtext}
          </DialogTitle>
          <CloseIconRed onClick={handleClose} />
        </Box>
        <Box sx={{textAlign:'center',alignItems:'center',justifyContent: 'center',display:'flex',height:'11.4rem',}}>
						<Typography sx={{fontWeight:'500', fontSize: '1.8rem',lineHeight:'2.1rem', width:'44.25rem'}}>{props.bodytext}</Typography> 
        </Box>
      </Box>
    </Dialog>
		</Box>
  );
};

export default SuccessDialog;
